// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    backendUrl: 'https://api-alpha.konta.tech',

    keycloakConfig: {
        realm: 'Konta',
        url: 'https://identity-alpha.konta.tech/auth',
        clientId: 'konta-web-ui'
    },
};

